import { action, makeObservable, observable } from "mobx";
import { ErrorMessages } from "../errorMessage";
import Validator from "../validator";

export enum PolicyDurationId {
    MONTHS_12 = "MONTHS_12",
    MONTHS_36 = "MONTHS_36"
}

export interface PolicyDurationVariantsModel {
    value: PolicyDurationId | undefined;
    label: string | null;
}

export const PolicyDurationVariants: PolicyDurationVariantsModel[] = [
    {
        value: PolicyDurationId.MONTHS_12,
        label: "12 miesięcy"
    },
    {
        value: PolicyDurationId.MONTHS_36,
        label: "36 miesięcy"
    }
];

export interface PolicyDurationModel {
    value: PolicyDurationId | undefined;
    errorMessage: string;

    validatePolicyDuration: () => void;
}

export class DefaultPolicyDuration implements PolicyDurationModel {
    @observable value: PolicyDurationId | undefined;
    @observable errorMessage: string;

    constructor(value: PolicyDurationId | undefined) {
        makeObservable(this);

        this.value = value;
        this.errorMessage = "";
    }

    @action
    public validatePolicyDuration = () => {
        if (!Validator.isNotEmpty(this.value!)) {
            this.errorMessage = ErrorMessages.required;
        } else {
            this.errorMessage = "";
        }
    }
}
